import React, { FC, ReactElement, useEffect } from 'react';

import styles from './styles.module.scss';

import { useAppDispatch, useAppSelector } from '../../../../../../store';
import { VOTER_DECENTRALIZATION } from '../../../../../../constants/organizationTabs';
import { PremiumTab } from '../../../../../PremiumTab';
import { OrganizationTabsActions } from 'store/actions';
import {
    ORGANIZATION_ACTIVE_VOTERS_TABLE_PARAMS,
    organizationActiveVotersTableHeaders,
} from './constants/organization-active-voters.constants';
import { LinkUtils } from '../../../../../../utils';
import { CommonTable } from '../CommonTable';
import {
    DELEGATES_TAB,
    DELEGATES_TAB_DESCRIPTIONS, VOTER_DECENTRALIZATION_TAB,
    VOTER_DECENTRALIZATION_TAB_DESCRIPTIONS
} from '../../../../../../constants';
import {
    ORGANIZATION_TOP_VOTERS_TABLE_PARAMS,
    organizationTopVotersTableHeaders,
} from './constants/organization-top-voters.constants';

export const OrganizationVoterDecentralization: FC = (): ReactElement => {
    const { organizationTabs, organizationActiveVoters, organizationTopVoters } = useAppSelector(
        ({ organizationTabs }) => organizationTabs,
    );
    const isTabBlocked = organizationTabs.data.find((t) => t.tab.name === VOTER_DECENTRALIZATION)?.isBlocked;
    const { organizationData } = useAppSelector(({ organization }) => organization);
    const organizationId = organizationData.id;

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(OrganizationTabsActions.getOrganizationActiveVoters.request({ organizationId }));
        dispatch(OrganizationTabsActions.getOrganizationTopVoters.request({ organizationId }));
    }, [organizationId]);

    const generatedOrganizationTopVoters = organizationTopVoters.data.map((otd) => {
        return {
            ...otd,
            ensName: {
                title: otd.ensName || otd.voterAddress,
                link: LinkUtils.createDynamicLink(otd.voterAddress, 'user'),
            },
        };
    });

    return (
        <div className={styles.container}>
            {isTabBlocked ? (
                <div className={styles.premiumWindow}>
                    <PremiumTab title="Voter Decentralization is a DeepDAO premium tab for this organization" />
                </div>
            ) : (
                <div className={styles.tablesWrapper}>
                    <div className={styles.topDelegates}>
                        <CommonTable
                            title="Top Voters"
                            infoText={VOTER_DECENTRALIZATION_TAB_DESCRIPTIONS[VOTER_DECENTRALIZATION_TAB.TOP_VOTERS]}
                            lastUpdate={organizationActiveVoters.lastUpdate}
                            tableRowsData={generatedOrganizationTopVoters as any}
                            loading={organizationTopVoters.loading}
                            tableHeaderData={organizationTopVotersTableHeaders}
                            sortedParamName={ORGANIZATION_TOP_VOTERS_TABLE_PARAMS.VOTING_POWER}
                        />
                    </div>
                    <div className={styles.activeDelegates}>
                        <CommonTable
                            title="Active Voters"
                            infoText={VOTER_DECENTRALIZATION_TAB_DESCRIPTIONS[VOTER_DECENTRALIZATION_TAB.ACTIVE_VOTERS]}
                            lastUpdate={organizationActiveVoters.lastUpdate}
                            tableRowsData={organizationActiveVoters.data}
                            loading={organizationActiveVoters.loading}
                            tableHeaderData={organizationActiveVotersTableHeaders}
                            sortedParamName={ORGANIZATION_ACTIVE_VOTERS_TABLE_PARAMS.NUMBER_VOTERS}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
